import { useState } from 'react';
import OrgLevelTypeHelpTextData from './OrgLevelTypeHelpTextData';

const useOrgLevelTypeHelpTextData = () => {
  const [ orgLevelTypeHelpTextState, setOrgLevelTypeHelpTextState ] = useState(OrgLevelTypeHelpTextData.INITIAL_STATE);

  const getOrgLevelTypeHelpText = (orgLevelTypeId) => {
    return OrgLevelTypeHelpTextData.getOrgLevelTypeHelpTextData(orgLevelTypeId, orgLevelTypeHelpTextState, setOrgLevelTypeHelpTextState);
  }

  return {
    orgLevelTypeHelpTextState,
    getOrgLevelTypeHelpText
  }
}

export default useOrgLevelTypeHelpTextData;